import {cn} from '@sollapay/ui';

import {TrustAccountCtaButton} from './TrustAccountCtaButton';

import type {FC, ReactNode} from 'react';

export interface TrustAccountCardActionProps {
  /** What the slot shows at rest, e.g. the account type. */
  rest: ReactNode;
  ctaLabel: string;
  onAction: () => void;
}

// On touch the call to action stays hidden, so focus conceals the resting content only where hover exists.
const REST_CLASS =
  'motion-safe:transition-opacity group-hover/row:opacity-0 [@media(hover:hover)]:group-has-[:focus-visible]/row:opacity-0';
const CTA_CLASS =
  'opacity-0 motion-safe:transition-opacity group-hover/row:opacity-100 group-has-[:focus-visible]/row:opacity-100 [@media(hover:none)]:invisible';

/** The card footer's end slot: its resting content, swapped for the call to action while the card is hovered or focused. */
export const TrustAccountCardAction: FC<TrustAccountCardActionProps> = ({
  rest,
  ctaLabel,
  onAction
}) => (
  <div
    data-slot="trust-account-card-action"
    className="grid min-w-0 items-center justify-items-end"
  >
    <div data-slot="card-rest" className={cn('col-start-1 row-start-1 min-w-0', REST_CLASS)}>
      {rest}
    </div>
    {/* Lifted above the card link's overlay so the button, not the card, takes the click. */}
    <div data-slot="card-cta" className={cn('relative z-10 col-start-1 row-start-1', CTA_CLASS)}>
      <TrustAccountCtaButton label={ctaLabel} onAction={onAction} />
    </div>
  </div>
);
